export const AppActionType = {
	DEVICE_SELECTION_CHANGED: 'DEVICE_SELECTION_CHANGED',
	DEVICE_SET_SELECTED: 'DEVICE_SET_SELECTED',
};

// Payload contract:
// --- for DEVICE_SELECTION_CHANGED: { type: "DEVICE_SELECTION_CHANGED", uri: "" }